
import React from 'react'
import { FiFacebook, FiInstagram, FiMail, FiHeart } from 'react-icons/fi'

export const Footer = () => {

    return (
        <div id="widget">
            <div className="footer_section">
                <div className="footer">
                    <div className="footer_intro">
                         <a  href='/' style={{fontSize:'40px', fontFamily:'Josefin Sans', fontWeight:700, marginRight:'.5em'}} >
                             HYPER NOVA
                         </a>
                        {/** <img src="/assets/images/logo/logo-wide.png" height="35" className="logo" /> **/}
                        <p className="description"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book </p>
                        <ul> 
                            <li><a href="/about"><FiFacebook className="facebook" /></a></li>
                            <li><a href="/about"><FiInstagram className="instagram" /></a></li>
                            <li><a href="/about"><FiMail className="mail" /></a></li>
                        </ul>
                    </div>
                    <div className="footer_list">
                        <div>
                            <a href="/about">Contact</a>
                            <a href="/about">Prices</a>
                            <a href="/about">FAQ</a>
                        </div>
                        <div>
                            <a href="/about" title="Personal data protection law" >Refund</a>
                            <a href="/about">Terms & Conditions</a>
                            <a href="/about">Privacy Policy</a>
                        </div>
                        <div>
                            <a href="/about">About</a>
                            <a href="/about">Ad</a>
                            <a href="/about">Blog</a>
                        </div>
                        <div>
                            <a href="/about">Support</a>
                            <a href="/about">Career</a>
                            <a href="/about">Cookies</a>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <div>Copyright ©️ <FiHeart className="red" /> All Rights Reserved.</div>
                    <div className="list">
                        <ul>
                            <li><a href="/about">Home</a></li>
                            <li><a href="/about">Com</a></li>
                            <li><a href="/about">Enterprise</a></li>
                            <li><a href="/about">Contact Us</a></li>
                            <li><a href="/about">Terms</a></li>
                            <li><a href="/about">Privacy</a></li>
                            <li><a href="/about">Status</a></li>
                        </ul>
                        <img src="/assets/images/assets/pay.png" height="15" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}
